// Radix overlays (Dialog, AlertDialog, Select, DropdownMenu…) lock page scrolling while they
// are open by setting `overflow: hidden` / `pointer-events: none` on <body> and marking it
// with `data-scroll-locked`. If an overlay is unmounted mid-close (e.g. by a route or tab
// change) that lock can be left behind and the page stops scrolling.
//
// `releaseStaleScrollLock()` clears any such leftover lock, but only when no overlay is
// actually open, so it never interferes with a dialog the user is looking at.

const OPEN_OVERLAY_SELECTOR = [
  "[data-radix-popper-content-wrapper]",
  '[role="dialog"][data-state="open"]',
  '[role="alertdialog"][data-state="open"]',
  '[role="listbox"][data-state="open"]',
  '[role="menu"][data-state="open"]',
  "ion-modal:not(.overlay-hidden)",
].join(", ");

export function releaseStaleScrollLock() {
  if (typeof document === "undefined") return false;
  if (document.querySelector(OPEN_OVERLAY_SELECTOR)) return false;
  for (const el of [document.body, document.documentElement]) {
    el.style.removeProperty("overflow");
    el.style.removeProperty("overflow-y");
    el.style.removeProperty("pointer-events");
    el.style.removeProperty("padding-right");
    el.style.removeProperty("margin-right");
    el.removeAttribute("data-scroll-locked");
  }
  return true;
}

// Runs the cleanup a few times over the first second after a page/tab lands, to catch
// overlays whose exit animation finishes (and would restore the lock) slightly later.
export function scheduleScrollLockRelease() {
  const timers = [0, 250, 800].map((ms) => setTimeout(releaseStaleScrollLock, ms));
  const raf = requestAnimationFrame(releaseStaleScrollLock);
  return () => {
    timers.forEach(clearTimeout);
    cancelAnimationFrame(raf);
  };
}
